import React from 'react';
import { Text, useTheme } from '@Sage/hoi-poi-ui';
import CircularPercentage from 'components/CircularPercentage';
import { getLiteral } from 'utils/getLiteral';
import './styles.scss';

const BillboardBall = ({
    className,
    percentage,
    strokeWidth,
    literalLegend,
    onClick,
    children,
}) => {
    const theme = useTheme();

    return (
        <div className={className} onClick={onClick}>
            <div className="ball">
                <CircularPercentage
                    rootClassName={'billboard-ball-percentage'}
                    percentage={percentage}
                    strokeWidth={strokeWidth}
                >
                    {children}
                </CircularPercentage>
            </div>
            {literalLegend && (
                <Text
                    type="caption"
                    as="div"
                    className="ball-legend"
                    color={theme.colors.utility.textSecondary}
                >
                    {getLiteral(literalLegend)}
                </Text>
            )}
        </div>
    );
};

export default BillboardBall;
